import StatisticsPage from "./Statistics";

export default StatisticsPage;
